<template>
  <div class="list" :style="{ height: height + 'px' }">
    <div v-if="items">
      <ListEntry
        v-for="item in items"
        :key="item.id"
        :item="item"
        @clicked="emit('item-clicked', $event)"
      />
    </div>
    <div v-else>No Entries</div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ListEntry from '@/components/utils/ListEntry.vue';

const props = defineProps({ items: Array, height: Number });

const emit = defineEmits(['item-clicked']);

</script>

<style lang="scss" scoped>

.list {
  height: 120px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  margin-top: 10px;
}

</style>
